import React from "react"
import Product from "./Product"
import {getProductIdentifierFrom} from "../../../helpers/productHelper";
import {ProductImageStacType} from "../../../types/product";

interface PropsType {
  items: ProductImageStacType[],
  detailsVersion: boolean
}

const ProductList = ({
  items,
  detailsVersion = false
}: PropsType) => {
  // Sort items by isMasterItem
  const itemsList = [...items].sort((item) => (item?.isMasterItem ? -1 : 1));

  return (
    <div className="container-search-results row m-0">
      {itemsList.map((item) => {
        const searchResultID = getProductIdentifierFrom(item);
        return (
          <Product
            key={`product-list-element-${searchResultID}`}
            searchResultID={searchResultID}
            item={item}
            detailsVersion={detailsVersion}
          />
        )
      })}
    </div>
  )
};

export default ProductList;
